import { GIFT_REGISTRY_WIDGET_NAMES } from "@/constants/widget-names";
import { defineModule } from "@modules/dynamic_import/utils/defineModule";

export const AddToRegistryModalWidgetDefinition = defineModule({
    name: GIFT_REGISTRY_WIDGET_NAMES.ADD_TO_REGISTRY_MODAL_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "AddToRegistryModalWidget" */ "./widgets/add_to_registry_modal_widget/AddToRegistryModalWidget"
        ),
});

export const AddToRegistryProductPageWidgetDefinition = defineModule({
    name: GIFT_REGISTRY_WIDGET_NAMES.ADD_TO_REGISTRY_PRODUCT_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "AddToRegistryProductPageWidget" */ "./widgets/add_to_registry_product_page_widget/AddToRegistryProductPageWidget"
        ),
});

export const GiftCartDrawerWidgetDefinition = defineModule({
    name: GIFT_REGISTRY_WIDGET_NAMES.GIFT_CART_DRAWER_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "GiftCartDrawerWidget" */ "./widgets/gift_cart_drawer_widget/GiftCartDrawerWidget"
        ),
});

export const RegistryFormModalWidgetDefinition = defineModule({
    name: GIFT_REGISTRY_WIDGET_NAMES.REGISTRY_FORM_MODAL_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RegistryFormModalWidget" */ "./widgets/registry_form_modal_widget/RegistryFormModalWidget"
        ),
});

export const SharedRegistryPageWidgetDefinition = defineModule({
    name: GIFT_REGISTRY_WIDGET_NAMES.SHARED_REGISTRY_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "SharedRegistryPageWidget" */ "./widgets/shared_registry_page_widget/SharedRegistryPageWidget"
        ),
});
export const GiftRegistryPageWidgetDefinition = defineModule({
    name: GIFT_REGISTRY_WIDGET_NAMES.GIFT_REGISTRY_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "GiftRegistryPageWidget" */ "./widgets/gift_registry_page_widget/GiftRegistryPageWidget"
        ),
});
